import React from 'react';

import { Logs, Log, LogText } from '@gogame/components';

import {
  STATUS_LABELS,
  STATUS_COLORS,
} from 'scenes/Gallery/GalleryPage/constants';

const StatusSchedulesLogs = ({ data }) => {
  return (
    <Logs>
      {data?.map(({ state, date }, i) => (
        <Log key={i} color={STATUS_COLORS[state]}>
          <LogText
            action={STATUS_LABELS[state]}
            date={date}
            dateTemplate={'LL'}
          />
        </Log>
      ))}
    </Logs>
  );
};

export default StatusSchedulesLogs;
